import React, { useCallback, useState } from 'react'
import { Menu, MenuItem, makeStyles, IconButton } from '@material-ui/core'
import PropTypes from 'prop-types'
import Icon from '../../../../atoms/Icon'
import { ICON_NAMES } from '../../../../../constants'
import FadeIn from '../../../../molecules/Transitions/FadeIn'

const useStyles = makeStyles((theme) => ({
  menuItem: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.layout.gap.medium,
    alignItems: 'center'
  },
  icon: {
    backgroundColor: 'var(--theme-color-surface-d0)',
    borderRadius: 'var(--border-radius-round)',
    border: 'var(--border-primary-thin)',
    boxShadow: theme.layout.shadow.normal
  },
  menuContainer: {
    position: 'relative'
  },
  menuTarget: {
    position: 'absolute',
    top: -9,
    right: -9
  }
}))

function ImageAssociationMenu ({ onDelete, children }) {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState()
  const open = useCallback((e) => {
    e.preventDefault()
    e.stopPropagation()
    setAnchorEl(e.target)
  }, [setAnchorEl])
  const close = useCallback(() => setAnchorEl(null), [])
  const withClose = useCallback((fn) => () => {
    fn()
    close()
  }, [close])

  return (
    <div className={classes.menuContainer}>
      {children}
      <FadeIn delay={0.75} className={classes.menuTarget}>
        <IconButton aria-controls='more-opts' aria-haspopup='true' onClick={open}>
          <Icon name={ICON_NAMES.vertDots} customSize={24} additionalClasses={classes.icon} />
        </IconButton>
      </FadeIn>
      <Menu
        id='image-actions'
        keepMounted
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={close}
      >
        <MenuItem onClick={withClose(() => onDelete?.())}>
          <div className={classes.menuItem}>
            <Icon name='close' />
            <div>Remove Image</div>
          </div>
        </MenuItem>
      </Menu>
    </div>
  )
}

ImageAssociationMenu.propTypes = {
  onDelete: PropTypes.func,
  children: PropTypes.node
}

ImageAssociationMenu.defaultProps = {
  size: '24px'
}

export default ImageAssociationMenu
